module.exports = {["template-constructor-control-picture_fwpos"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon noarrow" data-alt="Crop" data-alt-pos="left" data-alt-offset="9"></div>\n';
}
return __p;
},}